import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Nav } from './components/Nav';
import { Home } from './pages/Home';
import { About } from './pages/About';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen w-full overflow-x-clip" data-id="element-1">
        <Nav data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="/about" element={<About data-id="element-7" />} data-id="element-6" />
        </Routes>
      </div>
    </BrowserRouter>;
}